module.exports = __webpack_public_path__ + "static/media/top-sp.95bac712.png";